import { apiBaseUrl } from 'yxt-biz-pc/packages/api';

let apiTalent = 'sptalent';

export const getMapInfo = (enrollId) => {
  return apiBaseUrl.get(`${apiTalent}/mgr/trainmap/map/enroll/module/${enrollId}`);
};

export const getRecordApi = (recordId) => {
  return apiBaseUrl.get(`/enrollcenter/manage/records/${recordId}/detail`);
};
